import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitDeletePipelineOnFounder } from 'components/views/FounderPipeline/_helpers/founderPipeline.events';
import { $form, $view } from 'signals/global.signals';

const FounderPipelineDeleteModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-pipeline-delete'}
    title="Delete Opportunity"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitDeletePipelineOnFounder}
    primaryButtonColor="danger"
    primaryButtonText="Delete"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <p>Are you sure you want to remove <b className="text-warning">{$form.value.name}</b> from <b className="text-info">{$form.value.dealName}</b>? <br /><small className="text-gray-300">Note: This will NOT remove them from your account.</small></p>
  </SimpleModal>
);

export default FounderPipelineDeleteModal;
